import React from 'react'
type propsSide = {
    isActive: boolean,
    [key: string]: unknown;
}

export const SideC = ({ isActive  , ...props }: propsSide) => {
    let colorSide: string = `#EDEAE2`
    if (isActive) colorSide = `#425D76`

    let colorText: string = `#BBB5AA`
    if (isActive) colorText = `#040503`

    return (
        <svg width="77" height="83" viewBox="0 0 77 83" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M76 50.4083L61.1293 65.8083H1V31.8L15.8707 16.4L45.2888 1L76 16.4V50.4083Z" fill="white" />
            <path d="M15.8707 50.4083V16.4069L45.2888 1L76 16.4069V50.4083H15.8707Z" fill={colorSide} stroke={colorText} />
            <path d="M76 16.3999L61.1293 32.1207V65.8082L76 50.4082V16.3999Z" stroke={colorText} stroke-linejoin="round" />
            <path d="M1 65.8082V31.8068L30.4181 16.3999L61.1293 31.8068V65.8082H1Z" stroke={colorText} />
            <path d="M15.8707 16.3999L1 31.7999V65.8082L15.8707 50.4082V16.3999Z" stroke={colorText} stroke-linejoin="round" />
            <path d="M30.4181 16.4L45.6121 1" stroke={colorText} />
            <path d="M43.7028 79.4246C43.5709 80.5525 43.1534 81.4241 42.4503 82.0393C41.7521 82.6497 40.8219 82.9548 39.6598 82.9548C38.4 82.9548 37.3893 82.5032 36.6276 81.5999C35.8707 80.6965 35.4923 79.488 35.4923 77.9744V76.949C35.4923 75.9578 35.6681 75.0862 36.0197 74.3342C36.3761 73.5823 36.879 73.0061 37.5284 72.6057C38.1779 72.2004 38.9298 71.9978 39.7843 71.9978C40.9171 71.9978 41.8253 72.3152 42.5089 72.95C43.1925 73.5798 43.5905 74.4539 43.7028 75.572H42.2892C42.1671 74.7224 41.901 74.1072 41.4908 73.7263C41.0856 73.3455 40.5167 73.155 39.7843 73.155C38.8859 73.155 38.1803 73.4871 37.6676 74.1511C37.1598 74.8152 36.9059 75.76 36.9059 76.9856V78.0183C36.9059 79.1755 37.1476 80.0959 37.631 80.7795C38.1144 81.4631 38.7906 81.8049 39.6598 81.8049C40.441 81.8049 41.0392 81.6292 41.4542 81.2776C41.8741 80.9211 42.1525 80.3035 42.2892 79.4246H43.7028Z" fill={colorText} />
        </svg>

    )
}
